var develop = {
  legacy: "https://localhost:44301",
  message: "https://localhost:44388",
};
var test = {
  legacy: "https://web.test.ncare.nl",
  message: "https://chat.services.test.ncare.nl",
};
var testNew = {
  legacy: "https://web-test.ncare.nl",
  message: "https://chatapi-test.ncare.nl",
};
var acceptance = {
  legacy: "https://web.acceptance.ncare.nl",
  message: "https://chat.services.acceptance.ncare.nl",
};
var acceptanceNew = {
  legacy: "https://web-acc.ncare.nl",
  message: "https://chatapi-acc.ncare.nl",
};
var production = {
  legacy: "https://web.ncare.nl",
  message: "https://chat.services.ncare.nl",
};

export function GetLegacyUrl() {
  var currentUrl = window.location.hostname;
  var parentUrl = document.referrer;
  if (currentUrl.includes("localhost") || currentUrl.includes("127.0.0.1")) {
    return develop.legacy;
  }
  if (parentUrl && parentUrl.includes("web-test")) {
    return testNew.legacy;
  }
  if (currentUrl.includes("chat.test.ncare.nl")) {
    return test.legacy;
  }
  if (parentUrl && parentUrl.includes("web-acc")) {
    return acceptanceNew.legacy;
  }
  if (currentUrl.includes("chat.acceptance.ncare.nl")) {
    return acceptance.legacy;
  }
  if (currentUrl.includes("chat.ncare.nl")) {
    return production.legacy;
  }
}

export function GetMessageUrl() {
  var currentUrl = window.location.hostname;
  var parentUrl = document.referrer;
  if (currentUrl.includes("localhost") || currentUrl.includes("127.0.0.1")) {
    return develop.message;
  }
  if (parentUrl && parentUrl.includes("web-test")) {
    return testNew.message;
  }
  if (currentUrl.includes("chat.test.ncare.nl")) {
    return test.message;
  }
  if (parentUrl && parentUrl.includes("web-acc")) {
    return acceptanceNew.message;
  }
  if (currentUrl.includes("chat.acceptance.ncare.nl")) {
    return acceptance.message;
  }
  if (currentUrl.includes("chat.ncare.nl")) {
    return production.message;
  }
}



// WEBPACK FOOTER //
// ./src/config.js